<template>
  <div class="animated fadeIn remitos-list">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :filtroOpcion="filtroOpcion"
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          :cliente="cliente"
          :remitoDestino="remitoDestino"
          :remitoEstado="remitoEstado"
          :provincia="provincia"
          :localidad="localidad"
          :numeroPresupuesto="numeroPresupuesto"
          :numeroOrdenTrabajo="numeroOrdenTrabajo"
          :remitoEstadoPresupuesto="remitoEstadoPresupuesto"
          :transporte="transporte"
          :entregaPersonal="entregaPersonal"
          :usuario="usuario"
          :incluirAnulados="incluirAnulados"
          :numero="numero"
          :numeroPuntoVenta="numeroPuntoVenta"
          :sortByDescending="sortByDescending"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Remitos">
          <b-row>
            <b-col class="remitos-seleccionar-todo">
              <label class="text-muted">Seleccionar todos / eliminar selección</label>
              <b-form-checkbox
                  v-model="estadoRemitosSeleccionados" 
                  :indeterminate.sync="estadoRemitosSeleccionadosIndeterminado"
                  @click.native.prevent="actualizarSeleccionRemitos">
              </b-form-checkbox>
            </b-col>
          </b-row>

          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="remitos" 
              :fields="remitosFields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:cell(tieneImagenes)="data">
              <template v-if="data.item.tieneImagenes">
                <i class="fa fa-image"></i>
              </template>
            </template>
            <template v-slot:cell(fechaComprobante)="data">
              {{ data.item.fechaComprobante | fecha }}
            </template>
            <template v-slot:cell(fechaDespacho)="data">
              {{ data.item.fechaDespacho | fecha }}
            </template>
            <template v-slot:cell(fechaEntregaEstimada)="data">
              {{ data.item.fechaEntregaEstimada | fecha }}
            </template>
            <template v-slot:cell(fechaEntrega)="data">
              {{ data.item.fechaEntrega | fecha }}
            </template>
            <template v-slot:cell(montoDeclarado)="data">
              {{ data.item.montoDeclarado | moneda }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
            <template v-slot:cell(remitoInterno)="data">
              {{ data.item.remitoInterno? 'Si' : 'No' }}
            </template>
            <template v-slot:cell(anulado)="data">
              {{ data.item.anulado? 'Si' : 'No' }}
            </template>

            <!-- <template v-slot:row-details="row">
              <b-row>
                <b-col cols="12">
                  <p><span>Nro Presupuesto:</span> {{ row.item.presupuestoNumero  }}</p>
                  <p><span>Presupuesto:</span> {{ row.item.presupuestoInterno  }}</p>
                </b-col>
              </b-row>
            </template> -->

            <template v-slot:row-details="row">
              <b-row>
                <b-col cols="12">
                  <b-table hover
                    responsive="sm" 
                    :class="{ 'registro': true, 'details': true, 'no-presupuesto': !row.item.tienePresupuesto }"
                    :items="row.item.details" 
                    :fields="remitosPresupuestosFields">

                    <template v-slot:cell(presupuestoInterno)="row">
                      {{ row.item.presupuestoInterno }}
                    </template>
                    <template v-slot:cell(cantidadPallets)="row">
                      {{ row.item.cantidadPallets }}
                    </template>
                    <template v-slot:cell(cantidadBultos)="row">
                      {{ row.item.cantidadBultos }}
                    </template>
                    <template v-slot:cell(cantidadPaquetes)="row">
                      {{ row.item.cantidadPaquetes }}
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </template>

            <template v-slot:cell(opciones)="data">
              <template v-if="existenRemitosSeleccionados">
                <b-form-checkbox
                    v-model="data.item.selected"
                    @input="actualizarSeleccion(data.item)"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                </b-form-checkbox> 
              </template>
              <template v-if="!existenRemitosSeleccionados">
                <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                  <template slot="button-content">
                    <i class="fa fa-ellipsis-v"></i>
                  </template>

                  <b-dropdown-item
                      v-if="data.item.pendienteImpresion" 
                      @click.stop="actualizarNumeracion(data.item)">
                    <i class="fa fa-edit"></i>Actualizar Numeración</b-dropdown-item>

                  <b-dropdown-item
                      v-if="opcionLogistica"
                      @click.stop="actualizarEstado(data.item)">
                    <i class="fa fa-edit"></i>Actualizar Estado</b-dropdown-item>

                  <b-dropdown-item 
                      @click.stop="duplicar(data.item)">
                    <i class="fa fa-edit"></i>Duplicar Remito</b-dropdown-item>

                  <b-dropdown-item 
                      :disabled="data.item.anulado"
                      @click.stop="duplicarCancelar(data.item)">
                    <i class="fa fa-edit"></i>Duplicar y Anular Remito</b-dropdown-item>

                  <b-dropdown-item
                      @click.stop="emitirRemito(data.item)">
                    <i class="fa fa-file-pdf-o"></i>Emitir Remito</b-dropdown-item>

                  <b-dropdown-item 
                      @click.stop="descargarRemito(data.item)">
                    <i class="fa fa-download"></i>Descargar Remito</b-dropdown-item>

                  <b-dropdown-item
                      @click.stop="consultarImagenes(data.item)">
                    <i class="fa fa-image"></i>Consultar Imágenes del Remito</b-dropdown-item>

                  <b-dropdown-item 
                      @click.stop="descargarImagenes(data.item)">
                    <i class="fa fa-download"></i>Descargar Imágenes del Remito</b-dropdown-item>

                  <b-dropdown-item 
                      :disabled="data.item.anulado"
                      @click.stop="borrarItem(data.item)">
                    <i class="fa fa-remove"></i>Anular Remito</b-dropdown-item>

                  <b-dropdown-item 
                      @click.stop="seleccionarRemito(data.item)">
                    <i class="fa fa-check"></i>Seleccionar Remito</b-dropdown-item>

                  <b-dropdown-divider  v-if="opcionAgregarEvaluacion"></b-dropdown-divider>                  
                  
                  <b-dropdown-item 
                      v-if="opcionAgregarEvaluacion"
                      :disabled="data.item.evaluado || data.item.noEvaluar"
                      @click.stop="agregarEvaluacion(data.item)">
                    <i class="fa fa-star"></i>Evaluar Transporte</b-dropdown-item>
                </b-dropdown>
              </template>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item 
              @click.stop="agregar">
            <i class="fa fa-plus"></i>Remito</b-dropdown-item>
            <b-dropdown-item 
              @click.stop="agregarRemitoInterno">
            <i class="fa fa-plus"></i>Remito Interno</b-dropdown-item>
          <b-dropdown-item 
              @click.stop="agregarAnulado">
            <i class="fa fa-plus"></i>Remito Anulado</b-dropdown-item>

          <b-dropdown-divider v-if="existenRemitosSeleccionados"></b-dropdown-divider>

          <b-dropdown-item
              v-if="existenRemitosSeleccionados"
              @click.stop="actualizarEstadoSeleccionados">
            <i class="fa fa-edit"></i>Actualizar Estado</b-dropdown-item>

          <b-dropdown-item
              v-if="existenRemitosSeleccionados"
              @click.stop="actualizarDespachoSeleccionados">
            <i class="fa fa-edit"></i>Actualizar Despacho</b-dropdown-item>

          <b-dropdown-item
              v-if="existenRemitosSeleccionados"
              @click.stop="actualizarEntregaSeleccionados(true)">
            <i class="fa fa-edit"></i>Actualizar Entrega Estimada</b-dropdown-item>

          <b-dropdown-item
              v-if="existenRemitosSeleccionados"
              @click.stop="actualizarEntregaSeleccionados(false)">
            <i class="fa fa-edit"></i>Actualizar Entrega</b-dropdown-item>

          <b-dropdown-item
              v-if="existenRemitosSeleccionados"
              @click.stop="cancelarSeleccion">
            <i class="fa fa-remove"></i>Cancelar Selección</b-dropdown-item>

          <b-dropdown-divider></b-dropdown-divider>

          <b-dropdown-item
              @click.stop="exportXls(false)">
            <i class="fa fa-file-excel-o"></i>Exportar Listado de Remitos</b-dropdown-item>
          <b-dropdown-item
              v-if="existenRemitosSeleccionados"
              @click.stop="exportXls(true)">
            <i class="fa fa-file-excel-o"></i>Exportar Listado de Remitos Seleccionados</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-modal ref="actualizacionModal"
        title="Actualizar Numeración"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-actualizacion-numeracion
        :remitoId="remitoSeleccionado"
        @close="closeActualizacionNumeracion">
      </app-actualizacion-numeracion>  
    </b-modal>

    <b-modal ref="estadoModal"
        title="Actualizar Estado"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-estado
        :remitoId="remitoSeleccionado"
        @close="closeEstado">
      </app-estado>  
    </b-modal>

    <b-modal ref="actualizacionEstadoModal"
        title="Actualizar Estado"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-actualizacion-estado
        :remitoId="remitoSeleccionado"
        :remitos="remitosActualizar"
        :remitoEstadoActual="remitoSeleccionadoEstado"
        @close="closeActualizacionEstado">
      </app-actualizacion-estado>  
    </b-modal>

    <b-modal ref="actualizacionDespachoModal"
        title="Actualizar Despacho"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-actualizacion-despacho
        :remitoId="remitoSeleccionado"
        :remitos="remitosActualizar"
        @close="closeActualizacionDespacho">
      </app-actualizacion-despacho>  
    </b-modal>

    <b-modal ref="actualizacionEntregaModal"
        title="Actualizar Entrega"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-actualizacion-entrega
        :remitoId="remitoSeleccionado"
        :remitos="remitosActualizar"
        :entregaEstimada="actualizarEntregaEstimada"
        @close="closeActualizacionEntrega">
      </app-actualizacion-entrega>  
    </b-modal>

    <b-modal ref="agregarAnuladoModal"
        title="Agregar Anulado"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-agregar-anulado
        @close="closeAgregarAnulado">
      </app-agregar-anulado>  
    </b-modal>

    <b-modal ref="evaluacionProveedorModal"
        title="Evaluación del Proveedor"
        modal-class="modalABM modalEvaluacionProveedor"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-evaluacion-proveedor
        :remitoId="remitoId"
        @close="closeEvaluacionProveedor">
      </app-evaluacion-proveedor>  
    </b-modal>

    <b-modal ref="imagenesModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalOrdenTrabajo">
      <app-imagenes
        :remitoId="remitoId"
        :readonly="imagenesReadOnly"
        @close="closeImagenes">
      </app-imagenes>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import ActualizacionNumeracion from './ActualizacionNumeracion.vue';
import ActualizacionEstado from './ActualizacionEstado.vue';
import ActualizacionDespacho from './ActualizacionDespacho.vue';
import ActualizacionEntrega from './ActualizacionEntrega.vue';
import Estado from './Estado.vue';
import AgregarAnulado from './AgregarAnulado.vue';
import EvaluacionProveedor from '../evaluacionesProveedores/ABM.vue';
import Imagenes from './Imagenes.vue';
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import exportRemitoPDF from '../../mixins/export_remito_pdf';
import exportRemitoPreimpresoPDF from '../../mixins/export_remito_preimpreso_pdf';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'remitos/getField',
  mutationType: 'remitos/updateField',
});

export default {
  name: 'Remitos',
  components: {
    appActualizacionNumeracion: ActualizacionNumeracion,
    appActualizacionEstado: ActualizacionEstado,
    appActualizacionDespacho: ActualizacionDespacho,
    appActualizacionEntrega: ActualizacionEntrega,
    appEstado: Estado,
    appAgregarAnulado: AgregarAnulado,
    appEvaluacionProveedor: EvaluacionProveedor,
    appImagenes: Imagenes,
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal,
    exportRemitoPDF,
    exportRemitoPreimpresoPDF
  ],
  // props: {
  //   remitoInterno: {
  //     type: Boolean,
  //     default: false
  //   }
  // },
  data: () => {
    return {
      remitosFields: [
        { 
            key: 'tieneImagenes',
            label: '',
            class: 'text-center'
        },
        {
          key: 'fechaComprobante',
          label: 'Fecha',
        },
        {
          key: 'fechaDespacho',
          label: 'Fecha Despacho',
        },
        {
          key: 'fechaEntregaEstimada',
          label: 'Entrega Estimada',
        },
        {
          key: 'fechaEntrega',
          label: 'Fecha Entrega',
        },
        { 
          key: 'comprobante',
          label: 'Nro.Remito',
          sortable: true
        },
        { 
          key: 'remitoDestino',
          label: 'Destino',
          sortable: true 
        },
        { 
          key: 'formaEntrega',
          label: 'Transporte',
          sortable: true 
        },
        { 
          key: 'importe',
          label: 'Importe',
          class: 'text-right' 
        },
        { 
          key: 'remitoEstado',
          label: 'Estado'
        },
        { 
          key: 'remitoInterno',
          label: 'Interno',
          class: 'text-center'
        },
        { 
          key: 'anulado',
          label: 'Anulado',
          class: 'text-center'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      remitosPresupuestosFields: [
        { 
          key: 'col1',
          label: '',
        },
        { 
          key: 'cantidadPallets',
          label: 'Pallets',
          class: 'text-right'  
        },
        { 
          key: 'cantidadBultos',
          label: 'Bultos',
          class: 'text-right' 
        },
        { 
          key: 'cantidadPaquetes',
          label: 'Paquetes',
          class: 'text-right'  
        },
        { 
          key: 'presupuestoNumero',
          label: 'Nro. Presupuesto'
        },
        { key: 'presupuestoInterno' },
      ],     

      tableBusy: false,
      remitoSeleccionado: 0,
      remitosActualizar: null,
      remitoSeleccionadoEstado: null,
      actualizarEntregaEstimada: false,
      remitoId: 0,
      imagenesReadOnly: true,
      opcionAgregarEvaluacion: false,
      opcionLogistica: false
    }
  },
  computed: {
    ...mapFields([
      'remitos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'filtroOpcion',
      'fechaDesde',
      'fechaHasta',
      'cliente',
      'remitoDestino',
      'remitoEstado',
      'contacto',
      'provincia',
      'localidad',
      'numeroPresupuesto',
      'numeroOrdenTrabajo',
      'remitoEstadoPresupuesto',
      'transporte',
      'entregaPersonal',
      'usuario',
      'incluirAnulados',
      'sortByDescending',
      'numero',
      'numeroPuntoVenta',

      'remitosSeleccionados',
      'seleccionados',
      'seleccionadosIndeterminado',
    ]),
    fechaDesdeParam() {
      return moment(this.fechaDesde).format('YYYY-MM-DD');
    },
    fechaHastaParam() {
      return moment(this.fechaHasta).format('YYYY-MM-DD');
    },
    existenRemitosSeleccionados() {
      if (this.remitosSeleccionados) {
        return this.remitosSeleccionados.length != 0;
      }

      return false;
    },
    estadoRemitosSeleccionados: {
      get: function () {
        return this.seleccionados;
      },
      set: function (newValue) {
      }
    },
    estadoRemitosSeleccionadosIndeterminado: {
      get: function () {
        return this.seleccionadosIndeterminado;
      },
      set: function (newValue) {
      }
    },
  },
  created() {
    this.opcionLogistica = Boolean(this.$store.getters['user/tieneAccesoModulo']('RemitosActualizarEstado'));
    this.opcionAgregarEvaluacion = Boolean(this.$store.getters['user/tieneAccesoModulo']('RemitosAgregarEvaluacionTransporte'));
    this.imagenesReadOnly = !this.$store.getters['user/tieneAccesoModulo']('RemitosImagenesEdicion');

    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.filtroOpcion = filtro.filtroOpcion;
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      this.cliente = filtro.cliente;
      this.remitoDestino = filtro.remitoDestino;
      this.remitoEstado = filtro.remitoEstado;
      this.contacto = filtro.contacto;
      this.provincia = filtro.provincia;
      this.localidad = filtro.localidad;
      this.numeroPresupuesto = filtro.numeroPresupuesto;
      this.numeroOrdenTrabajo = filtro.numeroOrdenTrabajo;
      this.remitoEstadoPresupuesto = filtro.remitoEstadoPresupuesto;
      this.transporte = filtro.transporte;
      this.entregaPersonal = filtro.entregaPersonal;
      this.usuario = filtro.usuario;
      this.sortByDescending = filtro.sortByDescending;
      this.incluirAnulados = filtro.incluirAnulados;
      this.numero = filtro.numero;
      this.numeroPuntoVenta = filtro.numeroPuntoVenta;
      this.paginaActual = 1;
      
      this.$store.dispatch('remitos/inicializarRemitosSeleccionados')
        .then(() => this.getItems());      
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('remitos/getRemitos')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    agregar () {
      this.$router.push({ name: 'RemitoAlta' });
    },
    agregarRemitoInterno () {
      this.$router.push({ name: 'RemitoInternoAlta' });
    },
    duplicar (item) {
      if ((/true/i).test(item.remitoInterno)) {
        this.$router.push({ name: 'RemitoInternoDuplicado', 
                            params: { id: item.id }});
      } else {
        this.$router.push({ name: 'RemitoDuplicado', 
                            params: { id: item.id }});
      }
    },
    duplicarCancelar (item) {
      if ((/true/i).test(item.remitoInterno)) {
        this.$router.push({ name: 'RemitoInternoDuplicadoCancelado', 
                            params: { id: item.id }});
      } else {
        this.$router.push({ name: 'RemitoDuplicadoCancelado', 
                            params: { id: item.id }});
      }
    },
    consultar (item) {
      this.$router.push({ name: 'RemitoData', 
                            params: { id: item.id }});
    },
    borrarItem (item) {
      this.showModalConfirm('¿Desea anular el remito seleccionado?', 
            this.borrar.bind(this, item.id), 'Si', null, 'No')
    },
    borrar (remitoId) {
      this.showSpinner();
      this.$store.dispatch('remitos/delete', remitoId)
        .then(() => this.showModalMsj('El remito se anuló con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    emitirRemito(item) {
      this.getRemito(item.id, false, item.remitoInterno);
    },
    descargarRemito(item) {
      this.getRemito(item.id, true, item.remitoInterno);
    },
    getRemito(remitoId, save, remitoInterno) {
      this.showSpinner();
      let datosEmpresa = {};

      this.$store.dispatch('empresa/inicializar')
        .then(() => {
          return this.$store.getters['empresa/empresa'];
        })
        .then((empresa) => {
          datosEmpresa = empresa;
          return this.$store.dispatch('remito/getDatosRpt', remitoId);
        })
        .then(() => {
          if (remitoInterno) {
            this.exportRemitoPDF(this.$store.getters['remito/remitoDatosRpt'], 
              this.$store.getters['remito/remitoRenglonesDescripcionDatosRpt'], datosEmpresa, save);
            } else {
            this.exportRemitoPreimpresoPDF(this.$store.getters['remito/remitoDatosRpt'], 
              this.$store.getters['remito/remitoRenglonesDescripcionDatosRpt'], datosEmpresa, save);
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => {
          this.hideSpinner();
        })
    },
    actualizarNumeracion(item) {
      this.remitoSeleccionado = item.id;
      this.$refs.actualizacionModal.show();
    },
    closeActualizacionNumeracion(actualizado) {
      this.$refs.actualizacionModal.hide();
      if (actualizado) {
        this.getItems();
      }
    },
    agregarAnulado () {
      this.$refs.agregarAnuladoModal.show();
    },
    closeAgregarAnulado (actualizado) {
      this.$refs.agregarAnuladoModal.hide();
      if (actualizado) {
        this.getItems();
      }
    },
    agregarEvaluacion(item) {
      this.remitoId = item.id;
      this.$refs.evaluacionProveedorModal.show();
    },
    closeEvaluacionProveedor(saved) {
      this.$refs.evaluacionProveedorModal.hide();
      if (saved) {
        this.getItems();
      }
    },
    consultarImagenes(item) {
      this.remitoId = item.id;
      this.$refs.imagenesModal.show()
    },
    closeImagenes(params) {
      this.$refs.imagenesModal.hide();

      this.$store.dispatch('remitos/setRemitoTieneImagen', params)
        .catch(error => this.showErrorMsj(error));
    },
    descargarImagenes(item) {
      this.showSpinner();
      this.$store.dispatch('remito/descargarImagenes', item.id)
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },

    seleccionarRemito(item) {
      this.$store.dispatch('remitos/seleccionarRemito', item);
    },
    actualizarSeleccion(item) {
      this.$store.dispatch('remitos/actualizarRemitoSeleccionado', item);
    },
    cancelarSeleccion() {
      this.$store.dispatch('remitos/inicializarRemitosSeleccionados');
    },
    actualizarSeleccionRemitos() {
      this.$store.dispatch('remitos/actualizarSeleccion');
    },

    // seleccionarRemito(item) {
    //   let params = {
    //     remitoId: item.id,
    //     seleccionar: true
    //   }
    //   this.$store.dispatch('remitos/updateSeleccion', params)
    //     .catch(error => this.showErrorMsj(error));
    // },
    // updateSeleccion(item) {
    //   let params = {
    //     remitoId: item.id,
    //     seleccionar: item.selected
    //   }
    //   this.$store.dispatch('remitos/updateSeleccion', params)
    //     .catch(error => this.showErrorMsj(error));
    // },
    // clearSeleccion() {
    //   this.$store.dispatch('remitos/clearSeleccion')
    //     .catch(error => this.showErrorMsj(error));
    // },

    actualizarEstado(item) {
      this.remitoSeleccionado = item.id;
      this.$refs.estadoModal.show();
    },
    closeEstado(actualizado) {
      this.$refs.estadoModal.hide();
      if (actualizado) {
        this.$store.dispatch('remitos/inicializarRemitosSeleccionados')
          .then(() => this.getItems())
          .catch(error => this.showErrorMsj(error));
      }
    },
    actualizarEstadoSeleccionados() {
      this.remitoSeleccionado = 0;
      this.remitosActualizar = this.remitosSeleccionados.map(remito => ({
        remitoId: remito.id
      }))
      this.remitoSeleccionadoEstado = null;
      this.$refs.actualizacionEstadoModal.show();
    },
    closeActualizacionEstado(actualizado) {
      this.$refs.actualizacionEstadoModal.hide();
      if (actualizado) {
        this.$store.dispatch('remitos/inicializarRemitosSeleccionados')
          .then(() => this.getItems())
          .catch(error => this.showErrorMsj(error));
      }
    },
    actualizarDespacho(item) {
      this.remitoSeleccionado = item.id;
      this.remitosActualizar = null;
      this.$refs.actualizacionDespachoModal.show();
    },
    actualizarDespachoSeleccionados() {
      this.remitoSeleccionado = 0;
      this.remitosActualizar = this.remitosSeleccionados.map(remito => ({
        remitoId: remito.id
      }))
      this.$refs.actualizacionDespachoModal.show();
    },
    closeActualizacionDespacho(actualizado) {
      this.$refs.actualizacionDespachoModal.hide();
      if (actualizado) {
        this.$store.dispatch('remitos/inicializarRemitosSeleccionados')
          .then(() => this.getItems())
          .catch(error => this.showErrorMsj(error));
      }
    },    
    actualizarEntrega(item, entregaEstimada) {
      this.remitoSeleccionado = item.id;
      this.remitosActualizar = null;
      this.actualizarEntregaEstimada = entregaEstimada;
      this.$refs.actualizacionEntregaModal.show();
    },
    actualizarEntregaSeleccionados(entregaEstimada) {
      this.remitoSeleccionado = 0;
      this.remitosActualizar = this.remitosSeleccionados.map(remito => ({
        remitoId: remito.id
      }))
      this.actualizarEntregaEstimada = entregaEstimada;
      this.$refs.actualizacionEntregaModal.show();
    },
    closeActualizacionEntrega(actualizado) {
      this.$refs.actualizacionEntregaModal.hide();
      if (actualizado) {
        this.$store.dispatch('remitos/inicializarRemitosSeleccionados')
          .then(() => this.getItems())
          .catch(error => this.showErrorMsj(error));
      }
    },
    exportXls(exportarSeleccionados) {
      this.showSpinner();
      this.$store.dispatch('remitos/getList')
        .then(() => {
          let exportList = false; 
          let remitos = this.$store.getters['remitos/list'];

          if (exportarSeleccionados) {
            remitos = this.$store.getters['remitos/listSeleccionados'];
          }

          if (remitos) {
            if (remitos.length != 0) {
              exportList = true;
            }
          }
          if (exportList) {
            let title= 'Listado de Remitos';
            let fileName = 'remitos';
            let format = [
              { titulo: 'Fecha', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Fecha Despacho', nombre: 'fechaDespacho', formato: 'fecha' },
              { titulo: 'Entrega Estimada', nombre: 'fechaEntregaEstimada', formato: 'fecha' },
              { titulo: 'Fecha Entrega', nombre: 'fechaEntrega', formato: 'fecha' },
              { titulo: 'Nro.Remito', nombre: 'comprobante', formato: '' },
              { titulo: 'Destino', nombre: 'remitoDestino', formato: '' },
              { titulo: 'Transporte', nombre: 'formaEntrega', formato: '' },
              { titulo: 'Importe', nombre: 'importe', formato: '' },
              { titulo: 'Estado', nombre: 'remitoEstado', formato: '' },
              { titulo: 'Interno', nombre: 'remitoInterno', formato: 'bool' },
              { titulo: 'Anulado', nombre: 'anulado', formato: 'bool' },
              { titulo: 'Pallets', nombre: 'cantidadPallets', formato: '' },
              { titulo: 'Bultos', nombre: 'cantidadBultos', formato: '' },
              { titulo: 'Paquetes', nombre: 'cantidadPaquetes', formato: '' },
              { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
              { titulo: 'Presupuesto Interno', nombre: 'presupuestoInterno', formato: '' }
            ];

            this.exportXLS(title, fileName, remitos, format);
            
          } else {
            this.showErrorMsj('No hay datos para exportar.');
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
  .remitos-list table th {
    border-top: none;
  }

  .remitos-list table td[aria-colindex="1"] {
    width: 20px;
    opacity: 0.7;
  }
  .remitos-list table td[aria-colindex="2"] {
    width: 5%;
  }
  .remitos-list table td[aria-colindex="3"] {
    width: 5%;
  }
  .remitos-list table td[aria-colindex="4"] {
    width: 5%;
  }
  .remitos-list table td[aria-colindex="5"] {
    width: 5%;
  }
  .remitos-list table td[aria-colindex="6"] {
    width: 10%;
  }
  .remitos-list table td[aria-colindex="7"] {
    width: Calc(25% - 40px);
  }
  .remitos-list table td[aria-colindex="8"] {
    width: Calc(25% - 40px);
  }
  .remitos-list table td[aria-colindex="9"] {
    width: 10%;
  }
  .remitos-list table td[aria-colindex="10"] {
    width: 10%;
  }
  .remitos-list table td[aria-colindex="11"] {
    width: 40px;
  }
  .remitos-list table td[aria-colindex="12"] {
    width: 40px;
  }
  .remitos-list table td[aria-colindex="13"] {
    width: 50px;
  }

  .remitos-list tr.table-interno {
    background-color: rgba(27, 142, 183, 0.07);
  }
  .remitos-list tr.table-interno:hover {
    background-color: rgb(221, 238, 246);
  }

  .remitos-list tr.b-table-has-details td {
    padding-bottom: 3px;
  }
  .remitos-list tr.b-table-details td {
    padding-top: 0;
    padding-bottom: 10px;
  }
  
  .remitos-list tr.b-table-details td div.col-12 {
    padding-left: 0;
    padding-right: 0;
  }
  .remitos-list .registro.details {
    margin-bottom: 5px;
  }
  .remitos-list .registro.details table th,
  .remitos-list .registro.details table td {
    border: none;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .remitos-list .registro.details tr:hover {
    background-color: transparent;
  }

  .remitos-list .registro.details table td[aria-colindex="1"] {
    width: 20px;
  }
  .remitos-list .registro.details table td[aria-colindex="2"] {
    width: 5%;
  }
  .remitos-list .registro.details table td[aria-colindex="3"] {
    width: 5%;
  }
  .remitos-list .registro.details table td[aria-colindex="4"] {
    width: 5%;
  }
  .remitos-list .registro.details table td[aria-colindex="5"] {
    width: 10%;
  }
  .remitos-list .registro.details table td[aria-colindex="6"] {
    width: calc(75% - 20px);
  }

  .remitos-list .registro.details.no-presupuesto thead th[aria-colindex="5"],
  .remitos-list .registro.details.no-presupuesto thead th[aria-colindex="6"] {
    display: none;
  }
  
  span.fecha-entrega.estimada {
    font-style: italic;
  }

  .remitos-list tr.table-pendiente {
    background-color: rgba(232, 234, 237, 0.3);
  }
  .remitos-list tr.table-pendiente:hover {
    background-color: rgba(232, 234, 237, 0.5);
  }
  .remitos-list tr.table-en-preparacion {
    background-color: rgba(232, 234, 237, 0.3);
  }
  .remitos-list tr.table-en-preparacion:hover {
    background-color: rgba(232, 234, 237, 0.5);
  }
  .remitos-list tr.table-en-camino {
    background-color: rgba(200, 230, 250, 0.8);
  }
  .remitos-list tr.table-en-camino:hover {
    background-color: rgba(200, 230, 250, 1);
  }
  .remitos-list tr.table-en-camino,
  .remitos-list tr.table-en-camino .details .table,
  .remitos-list tr.table-en-camino:hover,
  .remitos-list tr.table-en-camino:hover .details .table {
    color: rgba(6, 6, 77, 1);
  }
  .remitos-list tr.table-pausado {
    background-color: rgba(240, 245, 155, 0.8);
  }
  .remitos-list tr.table-pausado:hover {
    background-color: rgba(240, 245, 155, 1);
  }
  .remitos-list tr.table-entregado {
    background-color: rgba(220, 250, 190, 0.8);
  }
  .remitos-list tr.table-entregado:hover {
    background-color: rgba(220, 250, 190, 1);
  }
  .remitos-list tr.table-entregado,
  .remitos-list tr.table-entregado .details .table,
  .remitos-list tr.table-entregado:hover,
  .remitos-list tr.table-entregado:hover .details .table {
    color: rgba(17, 115, 75, 1);
  }
  .remitos-list tr.table-conformado {
    background-color: rgba(57, 170, 123, 0.8);
  }
  .remitos-list tr.table-conformado:hover {
    background-color: rgba(57, 170, 123, 1);
  }
  .remitos-list tr.table-conformado,
  .remitos-list tr.table-conformado .details .table, 
  .remitos-list tr.table-conformado:hover, 
  .remitos-list tr.table-conformado:hover .details tr {
    color: white !important;
  }
  .remitos-list tr.table-conformado .b-dropdown i {
    color: white !important;
  }

  .remitos-list tr.table-pendiente.sin-numerar,
  .remitos-list tr.table-en-preparacion.sin-numerar,
  .remitos-list tr.table-en-camino.sin-numerar,
  .remitos-list tr.table-en-camino.sin-numerar .details .table,
  .remitos-list tr.table-en-camino.sin-numerar:hover,
  .remitos-list tr.table-en-camino-sin-numerar:hover .details .table,
  .remitos-list tr.table-pausado.sin-numerar,
  .remitos-list tr.table-entregado.sin-numerar,
  .remitos-list tr.table-entregado.sin-numerar .details .table,
  .remitos-list tr.table-entregado.sin-numerar:hover,
  .remitos-list tr.table-entregado.sin-numerar:hover .details .table,
  .remitos-list tr.table-conformado.sin-numerar,
  .remitos-list tr.table-conformado.sin-numerar .details .table, 
  .remitos-list tr.table-conformado.sin-numerar:hover, 
  .remitos-list tr.table-conformado.sin-numerar:hover .details tr {
    color: red;
  }

  .remitos-list .remitos-seleccionar-todo {
    display: inline-block;
    text-align: right;
    margin-bottom: 10px;
    padding-right: 30px;
  }
  .remitos-list .remitos-seleccionar-todo label {
    display: inline-block;
    font-size: 12px;
  }
  .remitos-list .remitos-seleccionar-todo .custom-checkbox {
    display: inline-block;
    width: 40px;
  }
</style>
